import { forwardRef } from 'react';

import type { IconButtonSize, IconButtonVariant, IconProps } from '../../types';

import { ButtonElement } from './IconButton.styled';

export interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.FC<IconProps>;
  variant?: IconButtonVariant;
  size?: IconButtonSize;
  label: string;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, forwardedRef) => {
    const {
      icon: Icon,
      variant = 'primary',
      size = 'medium',
      label,
      ...rest
    } = props;

    return (
      <ButtonElement
        {...rest}
        $size={size}
        $variant={variant}
        aria-label={label}
        ref={forwardedRef}>
        <Icon />
      </ButtonElement>
    );
  },
);

IconButton.displayName = 'IconButton';

export default IconButton;
